export default "__VITE_ASSET__Bswx5PVk__"